<div class="content content--compact">
    <img src="/assets/img/logoInvoice.svg" alt="SGC" style="width:100px;">
    <div>
        <h2>Nothing to see here...</h2>
        <p>What you're looking for may have been displaced.</p>
    </div>
    <p><a routerLink="/" class="button" style="background:#000;">Take me back home</a></p>
</div>
